import { render, staticRenderFns } from "./UserFamilyChildrenAdd.vue?vue&type=template&id=2e924049&"
import script from "./UserFamilyChildrenAdd.vue?vue&type=script&lang=js&"
export * from "./UserFamilyChildrenAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e924049')) {
      api.createRecord('2e924049', component.options)
    } else {
      api.reload('2e924049', component.options)
    }
    module.hot.accept("./UserFamilyChildrenAdd.vue?vue&type=template&id=2e924049&", function () {
      api.rerender('2e924049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserFamilyChildrenAdd.vue"
export default component.exports